<template>
  <div>
    <b-card no-body img-left v-for="i in count" :key="i" class="mb-2">
      <b-skeleton-img card-img="left" width="200px"></b-skeleton-img>
      <b-card-body>
        <b-skeleton animation="wave" width="85%"></b-skeleton>
        <b-skeleton animation="wave" width="55%"></b-skeleton>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'SkeletonNews',
  props: {
    count: {
      type: Number,
      default() {
        return 3
      }
    }
  }
}
</script>

<style scoped>

</style>
